import { EventBus } from '@/helpers/eventBus'

// YOU CAN USE THIS HOOK ON ROOT LEVEL AS:
//   data (...),
//   mounted () {...},
//   components: {...},
//   languageChanged (language_id) {
//     // do something with language_id
//   }

export default {
  install (Vue, options) {
    Vue.mixin({
      created () {
        if (this.$options.languageChanged) {
          this.onLanguageChanged = this.$options.languageChanged.bind(this)
          EventBus.$on('language:change', this.onLanguageChanged)
        }
      },
      beforeDestroy () {
        EventBus.$off('language:change')
      }
    })
  }
}
